'use strict';

let TransactionAmounts = {
  Authorize: '1000.00',
  Decline: '2000.00',
  Fail: '3000.00'
};

module.exports = {TransactionAmounts: TransactionAmounts};
